import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import argoCdPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import { navModule } from './modules/nav';
import { homePlugin } from './modules/home';

import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import techInsightsFrontendPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { techInsightsModule } from './modules/techInsights';
import { orgInsightsPlugin } from './modules/techInsights/orgInsightsPlugin';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    homePlugin,
    catalogPlugin,
    kubernetesPlugin,
    argoCdPlugin,
    navModule,
    githubActionsPlugin,
    techInsightsFrontendPlugin,
    techInsightsModule,
    orgInsightsPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
